// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronsUpDown: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M21.307 14.692 12 24l-9.308-9.308 1.063-1.064L12 21.872l8.244-8.244 1.064 1.064ZM2.693 9.308 12 0l9.308 9.308-1.063 1.064L12 2.128l-8.244 8.244-1.064-1.064Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ChevronsUpDownOffset: IconOffset = {
    vertical: 2, // Store Custom Code
    horizontal: 12, // Store Custom Code
};

export default React.memo(ChevronsUpDown);
